<template>
  <div :class="`card-info`" @click="close">
    <div class="content">
      <div >
        <card class="card" :title="$store.state.text.new_element">
          <div>
            <form @submit.prevent>

              <fields-list :fields="fields" :item="item" />
             
              <div class="clearfix"></div>

              <div class="save-panel">

                 <p-button
                  class=" mr-2"
          
                  round
                  @click.native.prevent="close($event, true)"
                  ><span class="ti-arrow-left"> Назад</span> </p-button
                >
                <p-button
                  class=""
                  type="info"
                  @click.native.prevent="addItem"
                  >{{'add' | setText('Добавить')}}</p-button
                >
     
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify, multiKeyInit, cardUpdate } from "@/plugins/functions";

export default {
  created() {
    let item = {};
    this.fields = [];
    this.fields = this.fieldsFrom.slice();

    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }

    this.item = this.multiKeyInit(item, this, 0);
  },
  data() {
    return {
      item: {},
      fields:[]
    };
  },
  props: {
    setLink: {
      default: "",
    },
    cardLink: {
      default: "",
    },
    openItem: {
      default: true,
    },
    modalTitle: {
      default: "",
    },
    modalCreate: {
      default: "",
    },
    fieldsFrom: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
    onCreateOpen: {
      default: true,
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  methods: {
    multiKeyInit: multiKeyInit,
    errorNotify: errorNotify,
    cardUpdate: cardUpdate,
    close(event, bool) {
      console.log(event, bool)
      if(event.target.classList.contains('card-info') || bool){
        this.item = {};
        this.$emit('close',true);
      }
    },
    modalOpen() {
      
    },
    async addItem() {
      let item = await this.cardUpdate(this.setLink, this.item, this.fields, 'POST' );

      if (item && item.id){
          this.$emit('close',true);

           if( this.openItem === true ){
            let query = Object.assign({}, this.$route.query);
            if (query[this.cardLink]) {
              delete query[this.cardLink];
            }
            query[this.cardLink] = item.id;
            setTimeout(() => {
              this.$router.replace({ query: query });
            }, 20);
            }
      }
    },
  },
};
</script>